<template>

    <Toast/>

    <MenuRegister/>
    <HeadingRegister/>

    <div class="px-6 surface-overlay relative">

        <div>
            <div class="bg-cover bg-no-repeat bg-top py-8 px-3 md:px-6 relative"
                 style="background: url(images/blocks/logos/kitrin-header-superhero1.jpg)">
                <div class="my-0 mx-auto w-full z-2 relative" style="max-width: 1200px">
                    <div class="flex flex-column align-items-center gap-5 mt-6 pt-0">

                        <span class="text-white text-2xl text-center line-height-6">&nbsp;</span>
                        <span class="text-white text-center text-7xl">Are You Looking for An Adaptive Practice Management Software?</span>
                        <span class="text-white text-2xl text-center line-height-3">We list everything you need to know below…</span>
                        <span class="text-white text-2xl text-center line-height-6">&nbsp;</span>
                        <span class="text-white text-2xl text-center line-height-6">&nbsp;</span>
<!--                        <Button label="Learn More" size="small" class="w-12rem"></Button>-->
                    </div>
                </div>
            </div>
        </div>

        <div>
            <div class="surface-section px-4 py-8 md:px-6 lg:px-8 overflow-hidden">
                <div class="text-900 font-bold text-6xl mb-4 text-center">Do you know how much admin you need to do on a weekly basis?
                </div>
                <div class="text-700 text-xl mb-6 text-center line-height-3">
                    If you cannot answer this question, we can help you with a
                    software solution that is simple, secure and
                    supported by a team of professionals that are dedicated to helping you.
                    <BR/><BR/>
                    Yes, you have many options for practice management software or medical billing software. Many of
                    these choices have been in the industry for an extremely long period of time.
                    <BR/><BR/>
                    However, as you get to know what we do and how we do it, and how we're
                    impacting the lives of our clients and their patients, we hope that you'll resonate with our story
                    and see how we can be an integral part
                    of the private practice that you want to create.
                </div>
            </div>
        </div>

        <div>
            <div class="surface-section px-4 py-8 md:px-6 lg:px-8 overflow-hidden">
                <div class="font-bold text-900 text-3xl mb-3 text-center">Explore the Benefits of the Kitrin IsoEvolve
                    Software
                </div>
                <div class="text-700 text-center mb-5 line-height-3">The only Adaptive Practice Management Software in South
                    Africa and the UK that has a CPD Module, a Practice Management Module and Managed
                    Service Module.
                </div>
                <div class="flex lg:justify-content-center mb-5">
                    <div class="py-3 pr-8 pl-3 w-30rem hidden lg:block">
                        <img src="images/blocks/feature/feature-timeline-1.png" alt="Image" class="w-full mr-8"/>
                    </div>
                    <div class="flex flex-column align-items-center w-2rem">
                    <span class="bg-blue-500 text-0 flex align-items-center justify-content-center border-circle"
                          style="min-width: 2.5rem; min-height: 2.5rem">1</span>
                        <div class="h-full bg-blue-500" style="width: 2px; min-height: 4rem"></div>
                    </div>
                    <div class="py-3 pl-5 lg:pl-8 pl-3 lg:w-30rem">
                        <div class="text-900 text-xl mb-2 font-medium">CPD Module</div>
                        <span class="block text-700 line-height-3 mb-3">An innovative way for each
                                    healthcare practitioner to get their CPD points for the year,
                                    which includes 24 clinical points and 6 ethical points.</span>
                        <div class="pt-3 border-top-1 border-300">
                            <div class="mb-2 line-height-3"><span class="text-900 font-medium">Introducing our</span>
                                IsoEvolve CPD Module
                            </div>
                        </div>
                        <img src="images/blocks/feature/feature-timeline-1.png" alt="Image"
                             class="w-full mt-3 block lg:hidden"/>
                    </div>
                </div>
                <div class="flex justify-content-center mb-5">
                    <div class="py-3 pl-5 pr-3 lg:pr-8 lg:pl-3 lg:w-30rem flex-order-1 lg:flex-order-0">
                        <div class="text-900 text-xl mb-2 font-medium">Practice Management Module</div>
                        <span class="block text-700 line-height-3 mb-3">Everything you would expect from a
                                    practice management software including making appointments,
                                    generating invoices and allowing your patients to complete electronic forms.</span>
                        <div class="pt-3 border-top-1 border-300">
                            <div class="mb-2 line-height-3"><span class="text-900 font-medium">Introducing our</span>
                                IsoEvolve Practice Management Module
                            </div>
                        </div>
                        <img src="images/blocks/feature/feature-timeline-2.png" alt="Image"
                             class="w-full mt-3 block lg:hidden"/>
                    </div>
                    <div class="flex flex-column align-items-center w-2rem flex-order-0 lg:flex-order-1">
                    <span class="bg-yellow-500 text-0 flex align-items-center justify-content-center border-circle"
                          style="min-width: 2.5rem; min-height: 2.5rem">2</span>
                        <div class="h-full bg-yellow-500" style="width: 2px; min-height: 4rem"></div>
                    </div>
                    <div class="py-3 pl-8 pr-3 w-30rem hidden lg:block flex-order-2">
                        <img src="images/blocks/feature/feature-timeline-2.png" alt="Image" class="w-full mr-8"/>
                    </div>
                </div>
                <div class="flex justify-content-center">
                    <div class="py-3 pr-8 pl-3 w-30rem hidden lg:block">
                        <img src="images/blocks/feature/feature-timeline-3.png" alt="Image" class="w-full mr-8"/>
                    </div>
                    <div class="flex flex-column align-items-center w-2rem">
                    <span class="bg-cyan-500 text-0 flex align-items-center justify-content-center border-circle"
                          style="min-width: 2.5rem; min-height: 2.5rem">3</span>
                        <div class="h-full bg-cyan-500" style="width: 2px; min-height: 4rem"></div>
                    </div>
                    <div class="py-3 pl-5 lg:pl-8 pl-3 lg:w-30rem">
                        <div class="text-900 text-xl mb-2 font-medium">Managed Service Module</div>
                        <span class="block text-700 line-height-3 mb-3">A revolutionary way to upgrade your
                                    current practice management software to allow you to
                                    have a dedicated phone number, get your phone calls answered while you're
                                    busy with clients, manage your referrals, get your invoicing done,
                                    and get all medical aids automatically followed up on. Even if you have a
                                    current billing company, it's a great way to see the progress
                                    of everything happening in your private practice.</span>
                        <div class="pt-3 border-top-1 border-300">
                            <div class="mb-2 line-height-3"><span class="text-900 font-medium">Introducing our</span>
                                IsoEvolve Managed Service Module
                            </div>
                        </div>
                        <img src="images/blocks/feature/feature-timeline-3.png" alt="Image"
                             class="w-full mt-3 block lg:hidden"/>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <div class="surface-section px-4 py-8 md:px-6 lg:px-8 overflow-hidden">
                <div class="text-orange-500 font-medium mb-3 text-center">Exclusive Insights</div>
                <div class="text-2xl font-medium mb-5 text-center text-900">Listen to the Experiences of Other
                    Healthcare Practitioners Using the Kitrin Products
                </div>

                <div class="surface-section px-4 py-8 md:px-6 lg:px-8 overflow-hidden">
                    <div class="flex flex-column md:flex-row">

                        <div class="flex flex-grow-1 mb-4 md:mb-0 md:px-4 py-4 md:py-0">
                            <div class="shadow-2 surface-card border-round relative">
                                <!--                            <img src="images/blocks/testimonial/testimonials-2.png" width="100" height="100"-->
                                <!--                                 class="absolute left-50" style="margin-left: -50px; top: -50px"/>-->

                                <div class="px-4 pb-4 pt-8 relative">
                                    <p class="text-900 font-italic line-height-3 text-lg m-0 pb-4 border-bottom-1 surface-border">
                                        “At Equanimity Wellness we needed a system that was user-friendly, precise and
                                        efficient. Kitrin is a superb software solution that seamlessly handles all aspects
                                        of running your practice. Oliver and his team have created a remarkable,
                                        customer-centric experience. We can't thank him and his team, nor recommend it,
                                        enough.”</p>

                                    <div class="text-900 font-semibold line-height-3 mt-4">Brad Kallenbach</div>
                                    <div class="text-600 line-height-3 text-sm">Clinical Psychologist</div>
                                </div>
                            </div>
                        </div>

                        <div class="flex flex-grow-1 mb-4 md:mb-0 md:px-4 py-4 md:py-0">
                            <div class="shadow-2 surface-card border-round relative">
                                <!--                            <img src="images/blocks/testimonial/testimonials-1.png" width="100" height="100"-->
                                <!--                                 class="absolute left-50" style="margin-left: -50px; top: -50px"/>-->

                                <div class="px-4 pb-4 pt-8 relative">
                                    <p class="text-900 font-italic line-height-3 text-lg m-0 pb-4 border-bottom-1 surface-border">
                                        “This is the best system I ever used out of all systems . The team is always a
                                        second away to help. I highly recommend them.
                                        Thank you for making my life more easier.”</p>

                                    <div class="text-900 font-semibold line-height-3 mt-4">Hulisani Godz</div>
                                    <div class="text-600 line-height-3 text-sm">Healthcare Practitioner</div>
                                </div>
                            </div>
                        </div>

                        <div class="flex flex-grow-1 md:px-4 py-4 md:py-0">
                            <div class="shadow-2 surface-card border-round relative">
                                <!--                            <img src="images/blocks/testimonial/testimonials-3.png" width="100" height="100"-->
                                <!--                                 class="absolute left-50" style="margin-left: -50px; top: -50px"/>-->

                                <div class="px-4 pb-4 pt-8 relative">
                                    <p class="text-900 font-italic line-height-3 text-lg m-0 pb-4 border-bottom-1 surface-border">
                                        “I have been using the Kitrin product since 2017 in my social work private practice.
                                        It has allowed me to have a professional invoicing system that can link to medical
                                        aid directly. This software has saved me a lot of time. The calendar is great for an
                                        overview of my billing and appointments. The reports make tax time quick (the income
                                        part). And the support from the Kitrin team is great. I have recommended this
                                        product to many people.”</p>

                                    <div class="text-900 font-semibold line-height-3 mt-4">Sally Baker</div>
                                    <div class="text-600 line-height-3 text-sm">Social Worker</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="surface-ground px-4 py-8 md:px-6 lg:px-8">
            <div class="text-900 font-bold text-4xl line-height-3 mb-3 text-center">Incredible Review from Ashton Robertson,
                a Clinical Psychologist based in South Africa.
            </div>
            <p class="text-600 line-height-3 text-lg m-0 mb-6 text-center">
                "My
                name is Ashton Robertson and I'm a Clinical Psychologist working in private practice.
                <BR/><BR/>
                I have been using the Kitrin product for a number of years and I'd really like to recommend them.
                Before making use of the Kitrin product I was doing my own administration and this was very
                compromising in terms of both my professional time and my personal time. With the Kitrin team doing
                my admin and accounts I can meaningfully use my free time with my family and have complete peace of
                mind that my business and reputation are in great hands.
                <BR/><BR/>
                A gap in most healthcare professional's training is a lack of business management. We are taught to
                be the utmost best in our professional fields, yet no one teaches us anything about tax record
                keeping, invoicing, running a business, websites, advertising etc- one thing I can say is that my
                lack of business knowledge is more than made up for with the kitrin team who keep my practice
                running smoothly in the background.
                <BR/><BR/>
                Kitrin is unique in that it can be tailored to your business needs and your budget. The software is
                user friendly, and the whole process is professional and transparent. You can look at your business
                stats for the day/week/month at a glance and know exactly what is occurring on an administrative and
                accounting level.
                <BR/><BR/>
                As a service team they go above and beyond for their clients. They are extremely innovative in their
                approach and are constantly working on updating, building and creating new ideas and keeping up with
                the times. I highly recommend their services."
            </p>
        </div>

        <div class="grid grid-nogutter">
            <div class="col-12 lg:col-6 xl:col-4 p-4">
                <div
                    class="surface-card shadow-2 p-4 flex flex-column align-items-center md:flex-row md:align-items-stretch h-full"
                    style="border-radius: 10px">
                    <div
                        class="flex flex-column align-items-center md:align-items-stretch ml-4 mt-4 md:mt-0">
                        <p class="mt-0 mb-3 line-height-3 text-center md:text-left">Appreciative of their user friendly
                            and efficient support staff service. Needed assistance in correcting an technical error. The
                            support staff responded swiftly to my request and helped me to resolve the issue in a matter
                            of minutes. Special thank you to Vanessa Bokgola.</p>
                        <span class="text-900 font-medium mb-1 mt-auto">Shani Senekal</span>
                        <div class="text-600 text-sm">Healthcare Practitioner</div>
                    </div>
                </div>
            </div>
            <div class="col-12 lg:col-6 xl:col-4 p-4">
                <div
                    class="surface-card shadow-2 p-4 flex flex-column align-items-center md:flex-row md:align-items-stretch h-full"
                    style="border-radius: 10px">
                    <div
                        class="flex flex-column align-items-center md:align-items-stretch ml-4 mt-4 md:mt-0">
                        <p class="mt-0 mb-3 line-height-3 text-center md:text-left">I have been using the Kitrin
                            products since October 2021. The consultants have always dealt with my queries in a
                            professional, supportive and timely manner. I would absolutely recommend using this amazing
                            service driven by passionate people, that could only add to your business success. They keep
                            up with market trends and strive to offer affordable, user friendly and ever evolving
                            products. Thank you!</p>
                        <div class="text-900 font-medium mb-1 mt-auto">Elisma Conradie</div>
                        <div class="text-600 text-sm">Healthcare Practitioner</div>
                    </div>
                </div>
            </div>
            <div class="col-12 lg:col-6 xl:col-4 p-4">
                <div
                    class="surface-card shadow-2 p-4 flex flex-column align-items-center md:flex-row md:align-items-stretch h-full"
                    style="border-radius: 10px">
                    <div
                        class="flex flex-column align-items-center md:align-items-stretch ml-4 mt-4 md:mt-0">
                        <p class="mt-0 mb-3 line-height-3 text-center md:text-left">As an occupational therapist with a
                            busy practice, Kitrin assists me in managing my accounts in an efficient manner. Since
                            utilising the system, I have had 100 percent payment recovery.</p>
                        <div class="text-900 font-medium mb-1 mt-auto">Ingrid Bench</div>
                        <div class="text-600 text-sm">Occupational Therapist</div>
                    </div>
                </div>
            </div>
            <div class="col-12 lg:col-6 xl:col-4 p-4">
                <div
                    class="surface-card shadow-2 p-4 flex flex-column align-items-center md:flex-row md:align-items-stretch h-full"
                    style="border-radius: 10px">
                    <div
                        class="flex flex-column align-items-center md:align-items-stretch ml-4 mt-4 md:mt-0">
                        <p class="mt-0 mb-3 line-height-3 text-center md:text-left">Thank you very very much to the
                            team. Vanessa much appreciated the time, patience, professionalism and friendly service you
                            gave me. Thank you 😊</p>
                        <div class="text-900 font-medium mb-1 mt-auto">Langa Ncaba</div>
                        <div class="text-600 text-sm">Healthcare Practitioner</div>
                    </div>
                </div>
            </div>
            <div class="col-12 lg:col-6 xl:col-4 p-4">
                <div
                    class="surface-card shadow-2 p-4 flex flex-column align-items-center md:flex-row md:align-items-stretch h-full"
                    style="border-radius: 10px">
                    <div
                        class="flex flex-column align-items-center md:align-items-stretch ml-4 mt-4 md:mt-0">
                        <p class="mt-0 mb-3 line-height-3 text-center md:text-left">I have been using this program for
                            the last 4 to 5 years and it has been an absolute pleasure. The customer support is
                            phenomenal and I found that my business ran like clock-work.</p>
                        <div class="text-900 font-medium mb-1 mt-auto">Alex Royal</div>
                        <div class="text-600 text-sm">Registered Dietician</div>
                    </div>
                </div>
            </div>
            <div class="col-12 lg:col-6 xl:col-4 p-4">
                <div
                    class="surface-card shadow-2 p-4 flex flex-column align-items-center md:flex-row md:align-items-stretch h-full"
                    style="border-radius: 10px">
                    <div
                        class="flex flex-column align-items-center md:align-items-stretch ml-4 mt-4 md:mt-0">
                        <p class="mt-0 mb-3 line-height-3 text-center md:text-left">Such an amazing system and efficient
                            support when needed!</p>
                        <div class="text-900 font-medium mb-1 mt-auto">Megan Pelkowitz</div>
                        <div class="text-600 text-sm">Healthcare Practitioner</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="surface-section px-4 py-8 md:px-6 lg:px-8 overflow-hidden">
            <div class="text-900 font-bold text-6xl mb-4 text-center">Choose the Pricing Plan that Suits You and
                Your Private Practice
            </div>
            <div class="text-700 text-xl mb-6 text-center line-height-3">If you need to discuss these options before signing
                up, complete your details below.
            </div>

            <div class="grid">
                <div class="col-12 lg:col-3">
                    <div class="p-3 h-full">
                        <div class="shadow-2 p-3 h-full flex flex-column surface-card" style="border-radius: 6px">
                            <div class="text-900 font-medium text-xl mb-2">Practice Management Module</div>
                            <div class="text-600">Ideal if you're just starting out your private practice, or have a smaller
                                practice and want to handle all
                                functions yourself.
                            </div>
                            <hr class="my-3 mx-0 border-top-1 border-none surface-border"/>
                            <div class="flex align-items-center">
                                <span class="font-bold text-2xl text-900">R250</span>
                                <span class="ml-2 font-medium text-600">per month</span>
                            </div>
                            <hr class="my-3 mx-0 border-top-1 border-none surface-border"/>
                            <ul class="list-none p-0 m-0 flex-grow-1">
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900"><B>30 Day Free Trial</B></span>
                                </li>
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Go Paperless with Electronic Forms</span>
                                </li>
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Online Patient Booking System</span>
                                </li>
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Appointment Scheduling</span>
                                </li>
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Appointment Waiting Room Functionality</span>
                                </li>
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Invoicing</span>
                                </li>
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Payment Allocation</span>
                                </li>
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Electronic Notes</span>
                                </li>
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Online Meetings or Telehealth Functionality, available with an add-on option that is billed separately</span>
                                </li>
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Manual Process of Unpaids Management (including Section 129 Notices)</span>
                                </li>
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Health Insurance Claim Submissions - Paper Based or EDI Based Electronic Submission</span>
                                </li>
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Health Insurance Claims via EDI Based Electronic Submission, SMSs and Section 129 Notices are billed separately and works on a prepaid concept</span>
                                </li>
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Pricing is based on a single practitioner. Additional practitioners are billed at R250 per practitioner per month.</span>
                                </li>
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Suitable for a single practitioner or as many practitioners as you would like</span>
                                </li>
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Ability to Load Applications on the Kitrin Store</span>
                                </li>
                            </ul>
                            <hr class="mb-3 mx-0 border-top-1 border-none surface-border mt-auto"/>
                            <Button label="Buy Now" class="p-3 w-full mt-auto" @click="buyPmMonthly"></Button>
                        </div>
                    </div>
                </div>

                <div class="col-12 lg:col-3">
                    <div class="p-3 h-full">
                        <div class="shadow-2 p-3 h-full flex flex-column surface-card" style="border-radius: 6px">
                            <div class="text-900 font-medium text-xl mb-2">Managed Service Module (Lite)</div>
                            <div class="text-600">Ideal if you know what needs to be done, but just need additional help with your
                                unpaids management functionality.
                            </div>
                            <hr class="my-3 mx-0 border-top-1 border-none surface-border"/>
                            <div class="flex align-items-center">
                                <span class="font-bold text-2xl text-900">R990</span>
                                <span class="ml-2 font-medium text-600">per month</span>
                            </div>
                            <hr class="my-3 mx-0 border-top-1 border-none surface-border"/>
                            <ul class="list-none p-0 m-0 flex-grow-1">
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900"><B>30 Day Free Trial</B></span>
                                </li>
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900"><B>Practice Management Module</B></span>
                                </li>
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Automation of Unpaids Management (including Section 129 Notices)</span>
                                </li>
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Marketing Functionality</span>
                                </li>
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Pricing is based on a single practitioner. Additional practitioners are billed at R250 per practitioner per month.</span>
                                </li>
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Suitable for a single practitioner or as many practitioners as you would like</span>
                                </li>
                            </ul>
                            <hr class="mb-3 mx-0 border-top-1 border-none surface-border"/>
                            <Button label="Buy Now" class="p-3 w-full" @click="buyMsLite"></Button>
                        </div>
                    </div>
                </div>

                <div class="col-12 lg:col-3">
                    <div class="p-3 h-full">
                        <div class="shadow-2 p-3 h-full flex flex-column surface-card" style="border-radius: 6px">
                            <div class="text-900 font-medium text-xl mb-2">Managed Service Module (Basic)</div>
                            <div class="text-600">Everything as with the IsoEvolve Management Service (Lite) product, but
                                with certain functions automated using a digital assistant.
                            </div>
                            <hr class="my-3 mx-0 border-top-1 border-none surface-border"/>
                            <div class="flex align-items-center">
                                <span class="font-bold text-2xl text-900">R1,790</span>
                                <span class="ml-2 font-medium text-600">per month</span>
                            </div>
                            <hr class="my-3 mx-0 border-top-1 border-none surface-border"/>
                            <ul class="list-none p-0 m-0 flex-grow-1">
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900"><B>30 Day Free Trial</B></span>
                                </li>
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900"><B>Practice Management Module</B></span>
                                </li>
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900"><B>Managed Service Module (Lite)</B></span>
                                </li>
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Full Tracking of ALL Processes and Tasks</span>
                                </li>
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Dedicated Telephone Number</span>
                                </li>
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Automated Call Answering</span>
                                </li>
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Allows automation of CERTAIN functions, using digital assistant functionality.</span>
                                </li>
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Pricing is based on a single practitioner and business entity.
                                    Additional practitioners are billed at R250 per practitioner per month.</span>
                                </li>
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Suitable for a single practitioner or as many practitioners as you would like</span>
                                </li>
                            </ul>
                            <hr class="mb-3 mx-0 border-top-1 border-none surface-border"/>
                            <Button label="Buy Now" class="p-3 w-full" @click="buyMsBasic"></Button>
                        </div>
                    </div>
                </div>


                <div class="col-12 lg:col-3">
                    <div class="p-3 h-full">
                        <div class="shadow-2 p-3 h-full flex flex-column surface-card" style="border-radius: 6px">
                            <div class="text-900 font-medium text-xl mb-2">Managed Service Module (Advanced)</div>
                            <div class="text-600">Ideal if you want everything to be tracked but also
                                want a one-stop-solution to ensure that everything gets done as you want it to be done.
                            </div>
                            <hr class="my-3 mx-0 border-top-1 border-none surface-border"/>
                            <div class="flex align-items-center">
                                <span class="font-bold text-2xl text-900">R2,790</span>
                                <span class="ml-2 font-medium text-600">per month</span>
                            </div>
                            <hr class="my-3 mx-0 border-top-1 border-none surface-border"/>
                            <ul class="list-none p-0 m-0 flex-grow-1">
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900"><B>30 Day Free Trial</B></span>
                                </li>
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900"><B>Practice Management Module</B></span>
                                </li>
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900"><B>Managed Service Module (Basic)</B></span>
                                </li>
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Allows automation of ALL functions, using digital assistant functionality and a human team.</span>
                                </li>
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Dedicated Team Allocated to You</span>
                                </li>
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Health Insurance Claim Follow-ups completed by dedicated team.</span>
                                </li>
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Dedicated Account Management</span>
                                </li>
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Pricing is based on up to two practitioners and a single business entity.
                                    Additional practitioners are billed at R250 per practitioner per month,
                                    and additional business entities are billed at R2,500 per entity per month.
                                </span>
                                </li>
                                <li class="flex align-items-center mb-3">
                                    <i class="pi pi-check-circle text-green-500 mr-2"></i>
                                    <span class="text-900">Suitable for a single practitioner or as many practitioners as you would like</span>
                                </li>
                            </ul>
                            <hr class="mb-3 mx-0 border-top-1 border-none surface-border"/>
                            <Button label="Buy Now" class="p-3 w-full" @click="buyMsAdvanced"></Button>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="surface-ground px-4 py-8 md:px-6 lg:px-8">
            <div class="text-900 font-bold text-4xl line-height-3 mb-3 text-center">We Will Continue Building Holistic
                Relationships with Healthcare Practitioners
            </div>
            <p class="text-600 line-height-3 text-lg m-0 mb-6 text-center">
                As a company, we're not interested in merely selling you a software subscription.
                You're worth more than that to us. That's the reason that we prioritise telling our stories and the stories
                of our clients,
                driving referrals and building private practices for our clients. We have a unique model that we're 100%
                sure that you would resonate with, since
                it has been battle tested by many of our clients across the various operational models in our software and
                business ecosystem.</p>

            <p class="text-600 line-height-3 text-lg m-0 mb-6 text-center">
                Here are some statistics of work that we have accomplished thus far with our clients.</p>

            <div class="grid surface-card shadow-2" style="border-radius: 10px">
                <div class="col-12 md:col-3 px-5 py-5">
                    <i class="pi pi-users text-4xl text-blue-600 mb-3"></i>
                    <div class="text-900 font-bold text-4xl mb-3 line-height-3">93+ Google Reviews</div>
                    <p class="text-700 m-0">We take pride in receiving the reviews and it is extremely gratifying to seeing
                        the depth of the words that the
                        clients use to express their thoughts on us and our products. It's not just a 5-star ranking. We
                        actually prefer the words since you can
                        hear them and they can possibly resonate with you.</p>
                </div>
                <div class="col-12 md:col-3 px-5 py-5">
                    <i class="pi pi-chart-line text-4xl text-orange-500 mb-3"></i>
                    <div class="text-900 font-bold text-4xl mb-3 line-height-3">90+ hours Of Interviews</div>
                    <p class="text-700 m-0">We use our Moulding Health and Moulding Private Practice Podcasts to connect to
                        healthcare practitioners,
                        learn from their stories and experiences, and build a resource for all aspiring healthcare
                        practitioners.</p>
                </div>
                <div class="col-12 md:col-3 px-5 py-5">
                    <i class="pi pi-globe text-4xl text-cyan-600 mb-3"></i>
                    <div class="text-900 font-bold text-4xl mb-3 line-height-3">60k+ Clients Reached</div>
                    <p class="text-700 m-0">We help our clients who help their patients. We feel connected to this journey
                        and the impact we make.</p>
                </div>
                <div class="col-12 md:col-3 px-5 py-5">
                    <i class="pi pi-map text-4xl text-purple-500 mb-3"></i>
                    <div class="text-900 font-bold text-4xl mb-3 line-height-3">2 Countries</div>
                    <p class="text-700 m-0">Our software solution works for healthcare practitioners in South Africa and the
                        United Kingdom.</p>
                </div>
            </div>
        </div>

        <div class="surface-section px-4 py-8 md:px-6 lg:px-8">
            <div class="flex flex-column lg:flex-row align-items-center justify-content-between">
                <div class="text-center lg:text-left lg:pr-8">
                    <div class="text-blue-600 font-medium mb-1 text-xl">TAKE THE NEXT STEP</div>
                    <div class="text-900 font-bold text-6xl mb-5">Get Started with the Kitrin IsoEvolve Software, our Adaptive Practice Management Software</div>

                    <span
                        class="inline-flex align-items-center bg-blue-50 px-3 py-2 mr-2 mb-2 lg:mb-0 border-1 border-blue-200"
                        style="border-radius: 50px">
                            <i class="pi pi-check text-blue-500 mr-2"></i>
                            <span class="text-gray-700 font-medium">1 Month Free Trial</span>
                        </span>
                    <span
                        class="inline-flex align-items-center bg-blue-50 px-3 py-2 mr-2 mb-2 lg:mb-0 border-1 border-blue-200"
                        style="border-radius: 50px">
                            <i class="pi pi-check text-blue-500 mr-2"></i>
                            <span
                                class="text-gray-700 font-medium">2 Month 100% Money-Back No-Questions-Asked Refund</span>
                        </span>
                    <span class="inline-flex align-items-center bg-blue-50 px-3 py-2 border-1 border-blue-200"
                          style="border-radius: 50px">
                            <i class="pi pi-check text-blue-500 mr-2"></i>
                            <span class="text-gray-700 font-medium">Guaranteed Personal Attention to You and Your Private Practice</span>
                        </span>
                </div>
            </div>
            <BR/>
            <div class="flex flex-column lg:flex-row align-items-center justify-content-between">

                <div class="col-12 md:col-12">
                    <div class="card p-fluid">

                        <div class="field">
                            <label for="firstName">First Name</label>
                            <InputText id="firstName" v-model="prospect.firstName" required="true"/>
                        </div>

                        <div class="field">
                            <label for="lastName">Last Name</label>
                            <InputText id="lastName" v-model="prospect.lastName" required="true"/>
                        </div>

                        <div class="field">
                            <label for="email">Email</label>
                            <InputText id="email" v-model="prospect.email" required="true"/>
                        </div>

                        <div class="field">
                            <label for="mobile">Mobile</label>
                            <InputText id="mobile" v-model="prospect.mobile" required="true"/>
                        </div>

                        <div class="field">
                            <label for="region">Region</label>
                            <Dropdown v-model="prospect.region" :options="regionTypes"
                                      optionLabel="name"
                                      optionValue="code"
                                      placeholder="Select a Region"/>
                        </div>

                        <div class="field">
                            <label for="type">Account Type</label>
                            <Dropdown v-model="prospect.type" :options="accountTypes"
                                      optionLabel="name"
                                      optionValue="code"
                                      placeholder="Select an Account Type"/>
                        </div>

                        <div v-show="prospect.type === 'H'" class="field">
                            <label for="practitionerType">Practitioner Type</label>
                            <Dropdown v-model="prospect.practitionerType" :options="practitionerTypes"
                                      optionLabel="name" optionValue="code"
                                      placeholder="Select a Practitioner Type"/>
                        </div>

                        <div class="field">
                            <label for="source">Where Did You Hear About Us?</label>
                            <InputText id="source" v-model="prospect.source" required="true"/>
                        </div>


                        <!--        <div class="mt-5 lg:mt-0 flex flex-wrap lg:flex-nowrap">-->
                        <Button label="Save" class="mr-2 mb-2" @click="createProspect"></Button>
                        <!--                    <Button label="Get Started"-->
                        <!--                            class="px-5 py-3 mr-0 lg:mr-3 p-button-rounded font-bold mb-3 lg:mb-0 w-full lg:w-auto white-space-nowrap"></Button>-->
                    </div>
                </div>
            </div>

        </div>


    </div>


    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import UserService from "@/service/UserService";
import {useUserStore} from "@/stores/UserStore";
import HeadingRegister from "@/components/heading/authentication/HeadingRegister.vue";
import ProspectService from "@/service/ProspectService";
import MenuRegister from "@/components/menu/authentication/MenuRegister.vue";

export default {
    components: {
        MenuRegister,
        HeadingRegister,
        IsoEvolveFooter
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    mounted() {
        UserService.getUserPing()
            .then(data => {
                console.log("[Login][mounted] System is active.");
                console.log("[Login][mounted] Data = ", data);
            })
            .catch(e => {
                console.log("[Login][mounted] System is NOT active.");
                console.log("[Login][mounted] Error = ", e);

                this.userStore.clearUser;
                window.location.href = "/#/login";
                window.location.reload();
            });
    },
    data() {
        return {
            activeTab: 1,
            userData: {},
            prospect: {},
            submitted: false,
            companyId: 114951,
            regionTypes: [
                {name: 'United Kingdom', code: 'UK'},
                {name: 'South Africa', code: 'ZA'},
                {name: 'United States', code: 'US'},
                {name: 'Canada', code: 'CA'},
                {name: 'India', code: 'IN'}
            ],
            accountTypes: [
                {name: 'Healthcare Practitioner', code: 'H'},
                {name: 'Financial Advisor', code: 'F'},
                {name: 'Small Business', code: 'S'}
            ],
            practitionerTypes: [
                {name: 'Occupational Therapist', code: 'A'},
                {name: 'Clinical Psychologist', code: 'B'},
                {name: 'Counselling Psychologist', code: 'C'},
                {name: 'Educational Psychologist', code: 'D'},
                {name: 'Industrial Psychologist', code: 'E'},
                {name: 'Psychologist', code: 'F'},
                {name: 'Psychiatrist', code: 'G'},
                {name: 'Social Worker', code: 'H'},
                {name: 'Registered Counsellor', code: 'I'},
                {name: 'Biokineticist', code: 'J'},
                {name: 'Physiotherapist', code: 'K'},
                {name: 'Speech Therapist', code: 'L'},
                {name: 'Audiologist', code: 'M'},
                {name: 'Speech Therapist and Audiologist', code: 'N'},
                {name: 'Dietician', code: 'O'},
                {name: 'Chiropractor', code: 'P'},
                {name: 'Podiatrist', code: 'Q'},
                {name: 'GP', code: 'R'},
                {name: 'Dentist', code: 'S'},
                {name: 'Specialist Physician', code: 'T'},
                {name: 'Registered Nurse', code: 'V'},
                {name: 'Anaesthetist', code: 'W'},
                {name: 'Gynaecologist', code: 'X'},
                {name: 'Other', code: 'U'}
            ]
        }
    },
    methods: {
        buyPmMonthly() {
            window.open("https://buy.stripe.com/8wM4i0cbD6TKfYYdSi", '_blank');
        },
        buyMsLite() {
            window.open("https://buy.stripe.com/dR64i08Zr91S3cc7tV", '_blank');
        },
        buyMsBasic() {
            window.open("https://buy.stripe.com/eVacOw1wZ7XO5kk15z", '_blank');
        },
        buyMsAdvanced() {
            window.open("https://buy.stripe.com/14kbKs0sV1zqbII8y2", '_blank');
        },
        createProspect() {
            this.submitted = true;

            if (this.prospect.firstName.trim()) {

                console.log("[" + name + "][createProspect] Before creating prospect back-end call. prospect = ", this.prospect);
                console.log("[" + name + "][createProspect] Before creating prospect back-end call. this.companyId = ", this.companyId);

                var note = "Key = firstName <BR/>";
                note = note + "Value = " + this.prospect.firstName + "<BR/><BR/>";

                note = note + "Key = lastName <BR/>";
                note = note + "Value = " + this.prospect.lastName + "<BR/><BR/>";

                note = note + "Key = email <BR/>";
                note = note + "Value = " + this.prospect.email + "<BR/><BR/>";

                note = note + "Key = mobile <BR/>";
                note = note + "Value = " + this.prospect.mobile + "<BR/><BR/>";

                note = note + "Key = source <BR/>";
                note = note + "Value = isoevolve/register <BR/><BR/>";

                note = note + "Key = region <BR/>";
                note = note + "Value = " + this.prospect.region + "<BR/><BR/>";

                note = note + "Key = type <BR/>";
                note = note + "Value = " + this.prospect.type + "<BR/><BR/>";

                note = note + "Key = practitionerType <BR/>";
                note = note + "Value = " + this.prospect.practitionerType + "<BR/><BR/>";

                var newProspectDto = {
                    firstName: this.prospect.firstName,
                    lastName: this.prospect.lastName,
                    email: this.prospect.email,
                    mobile: this.prospect.mobile,
                    note: note,
                    source: "isoevolve/register"
                };

                console.log("[" + name + "][createProspect] Before creating prospect back-end call. newProspectDto = ", newProspectDto);

                ProspectService.createExternalProspect(this.companyId, newProspectDto)
                    .then(data => {

                        console.log("[" + name + "][saveNewProspect] Data = ", data);

                        this.$toast.add({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Account Registered',
                            life: 3000
                        });


                    })
                    .catch(e => {
                        console.log("[" + name + "][saveNewProspect] Error = ", e);

                        this.$toast.add({
                            severity: 'error',
                            summary: 'Unsuccessful',
                            detail: 'Account NOT Registered',
                            life: 3000
                        });

                    });

            }

            this.prospect = {};

            this.submitted = false;
        },
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
